import BusinessInsights from "./BusinessInsights";
import AdditionalInfo from "./AdditionalInfo";

export{
    BusinessInsights,
    AdditionalInfo
}